<!-- Sidenav -->
<app-sidebar></app-sidebar>
<div class="main-content bg-secondary" style="background: #f4f4f4;">
  <!-- Top navbar -->
  <app-navbar></app-navbar>
  <!-- Pages -->
  <router-outlet></router-outlet>
  <div class="container-fluid bg-fondo">
    <app-footer></app-footer>
  </div>
</div>
